import { FC, useMemo } from 'react';
import { EntityChip, Tooltip } from '@silverfort/sf-components';

const TOTAL_ENTITIES_TO_DISPLAY = 2;

type EntityChipSummaryCellProps = {
    entities: Array<{ id: string; name: string }>;
    limit?: number;
};

export const EntityChipSummaryCell: FC<EntityChipSummaryCellProps> = ({ entities, limit }) => {
    const totalToDisplay = useMemo(() => limit ?? TOTAL_ENTITIES_TO_DISPLAY, [limit]);
    const hasExtraEntities = useMemo(() => entities.length - totalToDisplay > 0, [entities, totalToDisplay]);

    const renderedEntities = useMemo(() => {
        return hasExtraEntities ? entities.slice(0, totalToDisplay - 1) : entities;
    }, [entities, hasExtraEntities, totalToDisplay]);

    const restEntityNames = useMemo(() => {
        return hasExtraEntities ? entities.slice(totalToDisplay - 1).map((entity) => entity.name) : [];
    }, [entities, hasExtraEntities, totalToDisplay]);

    const restEntitiesTooltip = useMemo(() => restEntityNames.join(', '), [restEntityNames]);

    return (
        <div className="flex flex-wrap overflow-hidden gap-2">
            {renderedEntities.map((item) => (
                <EntityChip key={item.id} text={item.name} type="border" />
            ))}
            {restEntityNames.length > 0 && (
                <EntityChip
                    text={
                        <Tooltip placement="top" title={restEntitiesTooltip}>
                            <span className="text-12">+{restEntityNames.length}</span>
                        </Tooltip>
                    }
                />
            )}
        </div>
    );
};
